module.exports = __webpack_public_path__ + "img/login-bg.c4689a85.jpg";